/* stylelint-disable no-descending-specificity */
import styled, { css } from "styled-components"

const StyledWrapper = styled.div`
  display: flex;
  height: 100%;
  padding: 0 ${({ theme }) => theme.layout.mobilePadding};
  margin: 8rem auto 0;
  flex-direction: column;

  ${({ theme }) => theme.mq.medium} {
    flex-direction: row;
    margin: 0 auto;
  }

  ${({ theme }) => theme.mq.large} {
    padding: 0 1.6rem 1.6rem 11.6rem;
  }
`
const StyledTextWrapper = styled.div`
  width: 100%;

  ${({ theme }) => theme.mq.medium} {
    padding-top: 13.8rem;
    padding-right: 6.4rem;
    max-width: 53.5rem;
    border-right: 1px solid ${({ theme }) => theme.color.secondary04};
  }
`
const StyledProjecsWrapper = styled.div`
  max-width: 72.8rem;

  ${({ theme }) => theme.mq.medium} {
    padding-top: 13.8rem;
    padding-left: 6.4rem;
    flex: 1;
    padding-bottom: 112px;
    display: flex;
    flex-direction: column;
  }
`
const StyledProjectList = styled.div`
  grid-template-columns: repeat(2, 15.6rem);
  display: grid;
  gap: 3.1rem;

  &:nth-child(odd) {
    margin-left: 0;
  }

  ${({ theme }) => theme.mq.medium} {
    gap: 3.2rem;
    margin-top: 3.2rem;
    max-height: 45.6rem;
    overflow-y: auto;

    margin-right: -0.6rem;
    padding-right: 1rem;

    &::-webkit-scrollbar-track {
      background-color: ${({ theme }) => theme.color.secondary06};
    }

    &::-webkit-scrollbar {
      width: 6px;
      background-color: ${({ theme }) => theme.color.secondary06};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.color.secondary03};
    }
  }

  ${({ theme }) => theme.mq.large} {
    grid-template-columns: repeat(3, 16.8rem);
  }
`
const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.mq.medium} {
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    max-width: 56.8rem;
  }
`
const titleStyles = css`
  margin-bottom: 3.2rem;
  font-size: 3.2rem;

  ${({ theme }) => theme.mq.medium} {
    margin-bottom: 0;
  }
`

const headingStyles = css`
  margin-bottom: 3.2rem;

  ${({ theme }) => theme.mq.medium} {
    margin-bottom: 4.8rem;
  }

  > span {
    font-size: inherit;
    font-family: inherit;
    box-shadow: inset 0 -0.2em white,
      inset 0 -0.4em ${({ theme }) => theme.color.senary03};
  }
`

const textStyles = css`
  margin-bottom: 6.4rem;
  font-size: 1.8rem;
  line-height: 1.78;
  color: ${({ theme }) => theme.color.secondary01};
  white-space: pre-wrap;

  ${({ theme }) => theme.mq.medium} {
    margin-bottom: 0;
  }
`

const StyledCheckboxWrapper = styled.div`
  margin-bottom: 3.2rem;

  ${({ theme }) => theme.mq.medium} {
    margin-bottom: 0;
  }
`
export {
  StyledWrapper,
  StyledTextWrapper,
  StyledProjecsWrapper,
  StyledProjectList,
  StyledTitleWrapper,
  headingStyles,
  textStyles,
  titleStyles,
  StyledCheckboxWrapper,
}
